import {useState} from 'react';
import {commitTicketingMutation} from '../../../graphql/forecastRelay';
import DeleteTicketLinkMutation from '../../../../../mutations/ticketing/tickets/deleteTicketLinkMutation';

export function useDeleteTicketLink() {
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	function submit(id: string) {
		setError(null);
		setLoading(true);
		return new Promise((resolve, reject) => {
			commitTicketingMutation(
				DeleteTicketLinkMutation,
				{id},
				response => {
					setLoading(false);
					resolve(response.deleteTicketLink.deletedTicketLinkId);
				},
				err => {
					setLoading(false);
					setError(err instanceof Error ? err.message : String(err));
					reject(err);
				}
			);
		});
	}

	return {submit, loading, error};
}
